import React from 'react'
import PropTypes from 'prop-types'


type FormattedMessageProps = React.HTMLAttributes<HTMLElement> & {
  en: string
  es?: string
  values?: ReactIntlMessageValues
  tag?: string
  tagId?: string
  innerRef?: React.Ref<HTMLElement>
  dataTestId?: string
}

const FormattedMessage: React.FunctionComponent<FormattedMessageProps> = (props, context) => {
  const { intlData: { intl, locale } } = context
  const { children, tag, tagId, en, es, values, dataTestId, innerRef, ...rest } = props

  const message = intl.formatMessage({ en, es }, values, locale)

  if (typeof children === 'function') {
    return children(message)
  }

  return React.createElement(tag, {
    'data-testid': dataTestId, // should be before ...rest bcs there are <FormattedMessage data-testid="smth" /> places
    ...rest,
    id: tagId,
    ref: innerRef,
  }, message)
}

FormattedMessage.contextTypes = {
  intlData: PropTypes.object,
}

FormattedMessage.defaultProps = {
  tag: 'span',
}


export default React.memo(FormattedMessage)
